'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.todaysDate = exports.nextYear = exports.formatDate = exports.durationInMonths = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _arenaConfig = require('arena-config');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var durationInMonths = exports.durationInMonths = function durationInMonths(startDate, endDate) {
  var difference = (0, _moment2.default)(endDate).diff((0, _moment2.default)(startDate));

  var differenceInMonths = _moment2.default.duration(difference).asMonths();

  return Math.round(differenceInMonths);
};

var formatDate = exports.formatDate = function formatDate(value) {
  return value && (0, _moment2.default)(value, _arenaConfig.DATE_FORMAT).format(_arenaConfig.DATE_FORMAT);
};

var nextYear = exports.nextYear = function nextYear() {
  return (0, _moment2.default)(new Date()).add(1, 'years').format(_arenaConfig.DATE_FORMAT);
};

var todaysDate = exports.todaysDate = function todaysDate() {
  return (0, _moment2.default)(new Date()).format(_arenaConfig.DATE_FORMAT);
};